import { ATTENDANCE_SUMMARY_SUCCESS } from "../constants";

const initialState = {
  list: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
  case ATTENDANCE_SUMMARY_SUCCESS:
    return {
      ...state,
      list: action.payload
    };
  default:
    return state;
  }
}